import FormInput from 'components/ui/composed/declarations/formInput/DeclarationInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AddressForm from 'views/declarations/common/AddressForm';
import FormCard from 'views/declarations/common/cards/FormCard';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import { getFormikProps } from 'views/declarations/utils/form-utils';

const RemissionLocationType: FC<DeclarationFormCardProps> = ({
    selectCard,
    key,
    keyCard,
    defaultOpen = false,
    viewOnly = false,
    expandAll = false,
    cardTotal,
    cardNumber,
    getFieldHelpers,
    getFieldProps,
    getFieldMeta,
}) => {
    const { t } = useTranslation('form');
    return (
        <section
            id={'remission-locacation-type-form-card'}
            onClick={() => {
                if (selectCard) {
                    selectCard('remission-locacation-type-form-card');
                }
            }}
        >
            <FormCard
                key={keyCard}
                keyCard={keyCard}
                defaultOpen={defaultOpen}
                viewOnly={viewOnly}
                title={t('remissionRefund.locationType')}
                expandAll={expandAll}
                cardNumber={cardNumber}
                total={cardTotal}
                showRightSideCardState={false}
            >
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`identification`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('remissionRefund.identification')}
                />
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`additionalIdentifier`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('remissionRefund.additionalIdentifier')}
                />
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`locationTypeCode`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('remissionRefund.locationTypeCode')}
                />
                <FormInput
                    viewOnly={viewOnly}
                    {...getFormikProps(`qualifierIdentification`, { getFieldHelpers, getFieldProps, getFieldMeta })}
                    label={t('remissionRefund.qualifierIdentification')}
                />
                <AddressForm
                    viewOnly={viewOnly}
                    fieldProps={{
                        streetAndNumber: getFieldProps(`goodsLocationType.streetAndNumber`),
                        country: getFieldProps(`goodsLocationType.countryCode`),
                        postCode: getFieldProps(`goodsLocationType.postCode`),
                        city: getFieldProps(`goodsLocationType.city`),
                    }}
                    fieldMeta={
                        getFieldMeta && {
                            streetAndNumber: getFieldMeta(`goodsLocationType.streetAndNumber`),
                            country: getFieldMeta(`goodsLocationType.countryCode`),
                            postCode: getFieldMeta(`goodsLocationType.postCode`),
                            city: getFieldMeta(`goodsLocationType.city`),
                        }
                    }
                    fieldHelper={
                        getFieldHelpers && {
                            streetAndNumber: getFieldHelpers(`goodsLocationType.streetAndNumber`),
                            country: getFieldHelpers(`goodsLocationType.countryCode`),
                            postCode: getFieldHelpers(`goodsLocationType.postCode`),
                            city: getFieldHelpers(`goodsLocationType.city`),
                        }
                    }
                />
            </FormCard>
        </section>
    );
};
export default RemissionLocationType;
